// Action Types
export const SET_TEAM_MYTHIC_PLUS_RUNS = 'SET_TEAM_MYTHIC_PLUS_RUNS';
export const SET_TEAM_MYTHIC_PLUS_FILTERS = 'SET_TEAM_MYTHIC_PLUS_FILTERS';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const TOGGLE_OPEN_DUNGEON = 'TOGGLE_OPEN_DUNGEON';
export const SET_PENDING_SEASON = 'SET_PENDING_SEASON';

// Action Creator
const KeystoneTeamRunsActionCreator = {
  setPendingSeason(season: any) {
    return {
      type: SET_PENDING_SEASON,
      payload: season
    };
  },

  setKeystoneTeamMythicPlusRuns(eventId: number, details: any) {
    return {
      type: SET_TEAM_MYTHIC_PLUS_RUNS,
      payload: {
        eventId,
        details
      }
    };
  },

  setKeystoneTeamMythicPlusFilters(details: any) {
    return {
      type: SET_TEAM_MYTHIC_PLUS_FILTERS,
      payload: details
    };
  },

  showLoadingSpinner(eventId: number, show: boolean) {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: {
        eventId,
        show
      }
    };
  },

  toggleOpenDungeon(dungeonId: number, eventId?: number) {
    const nameSpace = eventId ? `${dungeonId}_${eventId}` : dungeonId;
    return {
      type: TOGGLE_OPEN_DUNGEON,
      payload: nameSpace
    };
  }
};

export default KeystoneTeamRunsActionCreator;
